module.exports = __webpack_public_path__ + "img/108.f499436c.jpg";